// front-end/multimodal/src/Context.tsx
import React, { createContext, useState, ReactNode, Dispatch, SetStateAction } from "react";

const getInitialFontSetting = (): boolean => {
  const value = localStorage.getItem("isScriptFontState");
  if (value === null || (value !== '0' && value !== '1'))
      return false;   // default value first usage
  return value === "1";
};

const initialValue = getInitialFontSetting();

interface MyContextType {
  isScriptFontState: boolean;
  setIsScriptFontState: Dispatch<SetStateAction<boolean>>;
}

const MyContext = createContext<MyContextType>({
  isScriptFontState: initialValue,
  setIsScriptFontState: () => {},
});

interface MyContextProviderProps {
  children: ReactNode;
}

const MyContextProvider: React.FC<MyContextProviderProps> = ({ children }) => {
  const [isScriptFontState, _setIsScriptFontState] = useState<boolean>(initialValue);

  const setIsScriptFontState = (value: SetStateAction<boolean>) => {
    const newValue = typeof value === 'function' ? value(isScriptFontState) : value;
    _setIsScriptFontState(newValue);
    localStorage.setItem("isScriptFontState", newValue ? "1" : "0");
  }

  return (
    <MyContext.Provider value={{ isScriptFontState, setIsScriptFontState }}>
      {children}
    </MyContext.Provider>
  );
}

export { MyContext, MyContextProvider };
